import React, { forwardRef, useState } from 'react';
import { TxInput } from 'texkit-ui';
import { ButtonIcon } from 'texkit/dist/components/Buttons';

import './ssn-format-input.scss';

const SSNFormInput = forwardRef((props, ref) => {
  const [inputType, setInputType] = useState('password');

  const InputIcon = (
    <ButtonIcon
      className="ssn-input-icon"
      icon={inputType === 'password' ? 'eye' : 'eye-closed'}
      onClick={() => {
        setInputType(inputType === 'password' ? 'text' : 'password');
      }}
      tabIndex="-1"
      aria-hidden={true}
      aria-label="password-eye-icon"
    />
  );

  return <TxInput {...props} ref={ref} icon={InputIcon} type={inputType} />;
});

SSNFormInput.displayName = 'SSNFormInput';

export default SSNFormInput;
